//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'auth',
  middleware: 'guest',
  data: () => ({
    formName: 'login',
    formData: {},
  }),
  methods: {
    async submit(data) {
      try {
        await this.$auth.loginWith('local', {data});
      } catch (err) {
        if (err.response?.status === 422) {
          this.$formulate.handle(err, this.formName);
        } else {
          this.$toast.error('Er is iets fout gegaan.');
          console.log(err);
        }
      }
    },
  },
  head: () => ({
    title: 'Inloggen',
  }),
};
